var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    y: 0.751953,
    width: 350,
    height: 233,
    fill: "#DC7D94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.996 133.705L205.371 106.941L285.781 146.034L222.407 172.798L141.996 133.705Z",
    fill: "#222D49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.843 71.2012V71.5139C202.843 71.5139 205.31 73.1739 206.311 74.1301L206.734 74.076V73.8054L202.843 71.2012Z",
    fill: "#1A2843"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.435 76.0939V76.5871C195.435 76.5871 204.777 76.8156 209.431 80.5926V79.8408C209.431 79.8408 205.309 76.2743 195.435 76.0879V76.0939Z",
    fill: "#121D31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.842 71.1999C213.568 70.9173 219.469 75.5423 219.469 75.5423L209.411 79.8485C204.518 76.2279 195.428 76.0956 195.428 76.0956C195.428 76.0956 199.775 74.0146 206.46 73.8883C206.46 73.8883 205.663 73.2027 204.757 72.5351C204.287 72.1923 202.842 71.1999 202.842 71.1999Z",
    fill: "#283D6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.222 93.4102L310.995 132.804V135.209L229.222 95.5152V93.4102Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M310.995 108.747V106.341L230.584 67.248L227.858 68.4509L310.995 108.747Z",
    fill: "#283B68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.21 122.879L230.584 96.1152L310.995 135.208L247.621 161.972L167.21 122.879Z",
    fill: "#4966A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.21 120.474L230.584 93.7109L310.995 132.804L247.621 159.868L167.21 120.474Z",
    fill: "#233457"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.21 96.4159L230.584 69.6523L310.995 108.745L247.621 135.509L167.21 96.4159Z",
    fill: "#3B548D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167.21 94.0116L230.584 67.248L310.995 106.341L247.621 133.104L167.21 94.0116Z",
    fill: "#5C7CC5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.21 94.0116L230.584 67.248L310.995 106.341L247.621 133.104L167.21 94.0116Z",
    fill: "url(#paint0_linear_567_21044)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.21 94.0117V123.181L247.621 162.274V133.105L167.21 94.0117Z",
    fill: "#243969"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.21 94.0117V123.181L247.621 162.274V133.105L167.21 94.0117Z",
    fill: "url(#paint1_linear_567_21044)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M310.313 133.104V108.746L247.961 134.607V159.867L310.313 133.104Z",
    fill: "#E1E8FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M310.313 133.104V108.746L247.961 134.607V159.867L310.313 133.104Z",
    fill: "url(#paint2_linear_567_21044)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.995 106.342V108.748L249.324 134.789V159.141L310.995 132.805V135.21L247.62 162.275V133.105L310.995 106.342Z",
    fill: "#2C4071"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_567_21044",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 77,
    width: 56,
    height: 28
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M210.973 104.78L194.162 96.7387L232.432 77.2344L249.243 85.2755L210.973 104.78Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_567_21044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.544 97.9917C206.483 98.0217 206.428 98.0518 206.36 98.0819L204.486 98.9299L199.77 96.4821L201.637 95.6341C203.218 94.9244 204.922 95.0627 206.305 95.7904C207.668 96.4881 207.907 97.3 206.544 97.9977M194.748 96.452L208.752 103.723L211.396 102.52L206.83 100.151L209.12 99.1103C209.236 99.0562 209.351 99.0021 209.46 98.9479C212.043 97.6308 211.723 95.9408 209.038 94.5515C206.278 93.1201 202.653 92.8555 199.757 94.1786L194.755 96.452",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.726 96.6541C216.983 97.033 217.065 97.6826 217.937 98.1156C218.816 98.5907 220.213 98.6629 221.044 98.284C221.065 98.272 221.085 98.266 221.106 98.2539C221.821 97.8931 221.753 97.2315 220.881 96.7744C219.988 96.3113 218.584 96.2452 217.807 96.606C217.773 96.6181 217.746 96.6361 217.719 96.6481",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.285 90.8288C222.224 90.8589 222.162 90.889 222.094 90.919L220.227 91.767L215.505 89.3132L217.372 88.4652C218.953 87.7555 220.656 87.8938 222.04 88.6216C223.403 89.3192 223.648 90.1312 222.285 90.8228M210.482 89.2771L224.486 96.5544L227.13 95.3515L222.564 92.9819L224.854 91.9415C224.97 91.8873 225.079 91.8332 225.181 91.7851C227.771 90.468 227.45 88.7779 224.766 87.3826C222.006 85.9512 218.38 85.6866 215.477 87.0037L210.476 89.2771",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.672 84.1946L235.682 91.4719L238.286 90.287L224.282 83.0098L221.672 84.1946Z",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.262 83.2374L236.194 85.0898C235.083 84.4643 234.906 83.6103 235.976 83.063C236.017 83.0389 236.064 83.0209 236.112 82.9968C237.264 82.4615 238.981 82.5758 240.269 83.2314M233.638 82.0345C231.131 83.3095 231.587 85.204 234.729 86.8279C238.047 88.56 241.925 88.8246 244.869 87.4955C244.971 87.4474 245.073 87.3993 245.168 87.3511C247.24 86.2926 247.478 84.9935 245.972 83.8629L243.492 84.9935C243.846 85.4145 243.669 85.9017 242.886 86.3047C242.851 86.3227 242.817 86.3407 242.776 86.3588C241.42 86.9662 239.587 86.8459 238 86.022L244.535 83.0509L243.717 82.6299C240.139 80.7715 236.412 80.7655 233.904 81.9082C233.809 81.9503 233.72 81.9924 233.631 82.0405",
    fill: "#FC7B72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_21044",
    x1: 197.706,
    y1: 86.7173,
    x2: 266.276,
    y2: 100.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7CC5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_567_21044",
    x1: 167.421,
    y1: 94.3069,
    x2: 196.08,
    y2: 131.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979729,
    stopColor: "#222D49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_567_21044",
    x1: 257.902,
    y1: 126.975,
    x2: 279.071,
    y2: 149.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary01);
export default __webpack_public_path__ + "static/media/library_01.9065110539639530613fd53b0558e709.svg";
export { ForwardRef as ReactComponent };